import { useTranslation } from 'react-i18next';
import { getScoreColor } from '@/types/vendor-kpi.ts';

interface SessionReportHeaderProps {
  simulationName?: string;
  maestroName: string;
  maestroColor: string;
  duration: string;
  globalScore: number;
}

export default function SessionReportHeader({
  simulationName,
  maestroName,
  maestroColor,
  duration,
  globalScore,
}: SessionReportHeaderProps) {
  const { t } = useTranslation();
  const scoreColor = getScoreColor(globalScore);

  return (
    <div className="mb-8 flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="text-3xl font-heading text-foreground">
          {t('report.title')}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {simulationName && <>{simulationName} — </>}
          {t('report.sessionWith')}{' '}
          <span className="font-semibold" style={{ color: maestroColor }}>
            {maestroName}
          </span>{' '}
          — {duration}
        </p>
      </div>
      <div className="flex flex-col items-center rounded-2xl border border-border bg-card p-5 sm:min-w-[140px]">
        <p className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
          {t('report.globalScore')}
        </p>
        <p className="mt-1 text-5xl font-extrabold" style={{ color: scoreColor }}>
          {globalScore}
        </p>
        <p className="text-xs text-muted-foreground">/99</p>
      </div>
    </div>
  );
}
